import $ from 'jquery';
import contentTemplate from 'properties/style/header-font.ejs';
import themeService from 'ThemeService';
import BasePropertyView from 'BasePropertyView'
import { pickerCfg } from 'pickerCfg';
import undoService from 'UndoService';
import util from 'util/Util';
import textConstants from 'TextConstants';
import fontService from 'FontService';

class StyleHeaderFontView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.selectedColor = 'lightgrey';
        this.unselectedColor = 'transparent';

        this.events = {
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'change #titleFontFamily, #customTitleFontFamily, #titleFontSize': 'updateAttributes',
            'click #titleBoldText, #titleItalicText': 'updateTextStyleAttributes',
            'change input[type=color]': 'updateColorAttributes',
            'change #titleColor': 'updateColorAttributesWithValidation'
        };

        if (!this.model.get('titleTextWeight')) {
            this.model.set('titleTextWeight', 'normal', { silent: true });
            this.model.set('titleBoldSelection', this.unselectedColor, { silent: true });
        }

        if (!this.model.get('titleTextStyle')) {
            this.model.set('titleTextStyle', 'normal', { silent: true });
            this.model.set('titleItalicSelection', this.unselectedColor, { silent: true });
        }

        if (this.model.get('titleTextStyle') === 'italic') {
            this.model.set('titleItalicSelection', this.selectedColor, { silent: true });
        }

        if (this.model.get('titleTextWeight') === 'bold') {
            this.model.set('titleBoldSelection', this.selectedColor, { silent: true });
        }

        // Add needed property
        let currentFont = this.resolveThemeFontProperty('titleFontFamily');
        if (!this.model.get('customTitleFontFamily')){
            this.model.set('customTitleFontFamily', '', {silent: true});    
            this.model.set('customTitleFontFamilyDisabled', 'disabled', {silent: true});
        }

        if (fontService.isCustomFont(currentFont)) {//If is a custom font
            currentFont = currentFont === "__custom__" ? "" : currentFont;
            this.model.set('customTitleFontFamily', currentFont, { silent: true });
            this.model.set('customTitleFontFamilyDisabled', '', { silent: true });
        }

                
        return this;
    }


    updateAttributes(ev, columnModel = undefined, name = undefined, value = undefined) {
        ev.preventDefault();
        let
            propName = ev.currentTarget.name || name,
            propVal = ev.currentTarget.name ? ev.currentTarget.value : value,
            oldValue = this.model.get(propName);

        if(propName === "customTitleFontFamily" || propName === "titleFontFamily"){
            if (fontService.isCustomFont(propVal)) {//If is a custom font
                propVal = propVal === "__custom__" ? "" : propVal;
                this.model.set('customTitleFontFamily', propVal, { silent: true });
                this.model.set('customTitleFontFamilyDisabled', '', {silent: true});
            }
            else{
                this.model.set('customTitleFontFamily', '', {silent: true});    
                this.model.set('customTitleFontFamilyDisabled', 'disabled', {silent: true});
            }
            this.model.set('titleFontFamily', propVal);
        }

        super.updateAttributes(ev, columnModel, name, value);

        if ( this.isThemeProperty(oldValue) ){
            themeService.deattachTheme(this);
        }
    }

    updateTextStyleAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name,
              oldValue = this.model.get(propName);
        let propVal = ev.currentTarget.value;
        var weight = this.model.get('titleTextWeight');
        var style = this.model.get('titleTextStyle');
        var oldWeight = this.model.get('titleTextWeight');
        var oldStyle = this.model.get('titleTextStyle');

        if (propName === 'titleTextWeight') {
            if (this.isThemeProperty(weight)) {//PF-2201 - Forms / Reports - General Bold / Italic
                weight = this.resolveAttributes(weight, 'titleTextWeight');
            }
            if (weight.indexOf('bold') > -1) {
                this.model.set('titleBoldSelection', this.unselectedColor, { silent: true });
                propVal = 'normal';
            } else {
                this.model.set('titleBoldSelection', this.selectedColor, { silent: true });
                propVal = 'bold';
            }
        }

        if (propName === 'titleTextStyle') {
            if (this.isThemeProperty(style)) {//PF-2201 - Forms / Reports - General Bold / Italic
                style = this.resolveAttributes(style, 'titleTextStyle');
            }
            if (style.indexOf('italic') > -1) {
                this.model.set('titleItalicSelection', this.unselectedColor, { silent: true });
                propVal = 'normal';
            } else {
                this.model.set('titleItalicSelection', this.selectedColor, { silent: true });
                propVal = 'italic';
            }
        }

        if ( this.isThemeProperty(oldValue) ){
            themeService.deattachTheme(this);
        }
        if(util.isGroupContainer(this.model.get('factoryKey'))){
            util.updatePropertyRenderAndSendEvent(propName,propVal,this.model,this.render.bind(this),'GroupPropertyChange');

        }else{
            this.model.set(propName, propVal);
        }

        undoService.add({
            undo: () =>{
                let oldPropVal;
                if (propName === 'titleTextWeight') {
                    if (this.isThemeProperty(oldWeight)) {//PF-2201 - Forms / Reports - General Bold / Italic
                        oldWeight = this.resolveAttributes(oldWeight, 'titleTextWeight');
                    }
                    if (oldWeight.indexOf('bold') > -1) {
                        this.model.set('titleBoldSelection', this.selectedColor, { silent: true });
                        oldPropVal = 'normal';
                    } else {
                        this.model.set('titleBoldSelection', this.unselectedColor, { silent: true });
                        oldPropVal = 'bold';
                    }
                }

                if (propName === 'titleTextStyle') {
                    if (this.isThemeProperty(oldStyle)) {//PF-2201 - Forms / Reports - General Bold / Italic
                        oldStyle = this.resolveAttributes(oldStyle, 'titleTextStyle');
                    }
                    if (oldStyle.indexOf('italic') > -1) {
                        this.model.set('titleItalicSelection', this.selectedColor, { silent: true });
                        oldPropVal = 'normal';
                    } else {
                        this.model.set('titleItalicSelection', this.unselectedColor, { silent: true });
                        oldPropVal = 'italic';
                    }
                }
                if(util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(propName,oldPropVal,this.model,this.render.bind(this),'GroupPropertyChange');

                }else{
                    this.model.set(propName, oldPropVal);
                }
            },
            redo:() => {
                if (propName === 'titleTextWeight') {
                    if (this.isThemeProperty(weight)) {//PF-2201 - Forms / Reports - General Bold / Italic
                        weight = this.resolveAttributes(weight, 'titleTextWeight');
                    }
                    if (weight.indexOf('bold') > -1) {
                        this.model.set('titleBoldSelection', this.unselectedColor, { silent: true });
                        propVal = 'normal';
                    } else {
                        this.model.set('titleBoldSelection', this.selectedColor, { silent: true });
                        propVal = 'bold';
                    }
                }

                if (propName === 'titleTextStyle') {
                    if (this.isThemeProperty(style)) {//PF-2201 - Forms / Reports - General Bold / Italic
                        style = this.resolveAttributes(style, 'titleTextStyle');
                    }
                    if (style.indexOf('italic') > -1) {
                        this.model.set('titleItalicSelection', this.unselectedColor, { silent: true });
                        propVal = 'normal';
                    } else {
                        this.model.set('titleItalicSelection', this.selectedColor, { silent: true });
                        propVal = 'italic';
                    }
                }

                if(util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(propName,propVal,this.model,this.render.bind(this),'GroupPropertyChange');

                }else{
                    this.model.set(propName, propVal);
                }
            }
        },textConstants.UNDO_PROP_CHANGE);
    }

    resolveAttributes(base, name) {
        let fontPropsArray = themeService.resolve(base).split(',');
        let result = 'normal';
        if (name === 'titleTextWeight') {
            if (fontPropsArray[2]) {
                result = fontPropsArray[2].trim().toLowerCase();
            }
        } else {
            if (fontPropsArray[3]) {
                result = fontPropsArray[3].trim().toLowerCase();
            }
        }
        return result;
    }

    resolveThemeTitleFontProperty(property) {
        let val = `${this.model.get(property)}`;
        if (this.isThemeProperty(val)) {
            let propArray = themeService.resolve(val).split(',');
            switch (property) {
                case 'titleFontFamily':
                    return propArray[0].trim();
                case 'titleFontSize':
                    return propArray[1].trim();
                case 'titleTextWeight':
                    return propArray[2].trim();
                default:
                    break;
            }
        } else {
            val = val.replace("px","");
            return val;
        }
    }

    selectMask(value) {
        switch (value) {
            case 'bold': return this.selectedColor;
            case 'italic': return this.selectedColor;
            default: return this.unselectedColor;
        }
    }

    updateForm() {
        //set selected index to model value
        if (this.model.get('titleFontSize')) {
            $('#titleFontSize')
                .find(`option[value="${this.resolveThemeTitleFontProperty('titleFontSize')}"]`)
                .attr(`selected`, true);
        }
        if (this.model.get('titleFontFamily')) {
            let titleFontFamily = this.resolveThemeTitleFontProperty('titleFontFamily');
            const customFont = fontService.isCustomFont(titleFontFamily);
            titleFontFamily = !customFont ? titleFontFamily : "__custom__";
            $('#titleFontFamily')
                .find(`option[value="${titleFontFamily}"]`)
                .attr(`selected`, true);
        }
    }


    render() {
        super.render();

        let props = this.resolveThemeColors(this.model, ['titleColor']);
        
        if (this.isThemeProperty(props.titleTextWeight)) {
            props.titleTextWeight = this.resolveAttributes(props.titleTextWeight, 'titleTextWeight');
            props.titleBoldSelection = this.selectMask(props.titleTextWeight);
        }

        if (this.isThemeProperty(props.titleTextStyle)) {
            props.titleTextStyle = this.resolveAttributes(props.titleTextStyle, 'titleTextStyle');
            props.titleItalicSelection = this.selectMask(props.titleTextStyle);
        }

        this.$el.html(this.template(props));

        const fonts = fontService.loadFontsDropDown(true);
        $("#titleFontFamily").append(fonts);
        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.updateForm();
        this.delegateEvents();

        return this;
    }


}

export default StyleHeaderFontView;
